export const tokenLogger = {
  init() {
    const storage = window.localStorage.getItem("tokenLogger");
    if (!storage) {
        window.localStorage.setItem("tokenLogger", "[]")
    } 
  },
  getStorage() {
    const storage = window.localStorage.getItem("tokenLogger");
    return JSON.parse(storage || "[]");
  },
  setStorage(props: itemProps) {
    window.localStorage.setItem("tokenLogger", JSON.stringify(props))
  },
  setStart(from: string, time: string, oldToken: string, fingerPrint: string, idProfile: string) {
    const storage = this.getStorage();
    const newItem = { from, time, oldToken, fingerPrint, idProfile }
    storage.push(newItem)
    this.setStorage(storage)
  },
  setSuccess(newToken: string) {
    const storage = this.getStorage();
    storage[storage.length] = { ...storage[storage.length], newToken }
    this.setStorage(storage.splice(storage.length - 100, storage.length))
  },
  setFail(err: any) {
    const storage = this.getStorage();
    storage[storage.length] = { ...storage[storage.length], err }
    this.setStorage(storage.splice(storage.length - 100, storage.length))
  },
  log() {
    
  }
};

type itemProps = {
    from?: string;
    time?: string;
    oldToken?: string;
    err?: any;
    newToken?: string;
    fingerPrint?: string;
    idProfile?: string;
}

//@ts-ignore
window.tokenLogger = tokenLogger